import { render, staticRenderFns } from "./ButtonGoogleAuth.vue?vue&type=template&id=328edf62&"
import script from "./ButtonGoogleAuth.vue?vue&type=script&lang=js&"
export * from "./ButtonGoogleAuth.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGoogleAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports